import React from 'react';
import {
  required,
  BooleanInput,
  Create,
  FileField,
  FileInput,
  ImageField,
  ImageInput,
  ReferenceInput,
  SelectInput,
  SimpleForm,
  TextInput
} from 'react-admin';
import { Divider, Typography } from '@mui/material';
import FolderIcon from '@mui/icons-material/Folder';
import SettingsIcon from '@mui/icons-material/Settings';

import { handleRelated } from '../utils';
import { TemplateTypes } from './constants';
import { SectionLabel } from './components';

const TemplateCreate = props => (
  <Create redirect="list" {...props}>
    <SimpleForm sx={{ maxWidth: 720, '& .RaSimpleForm-form': { gap: 0 } }}>
      <Typography variant="subtitle1" fontWeight={600} mb={2}>General</Typography>
      <TextInput fullWidth source="name" validate={[required()]} />
      <TextInput fullWidth source="version" />
      <SelectInput source="type" choices={TemplateTypes} validate={[required()]} fullWidth />
      <BooleanInput source="hasHotspots" />
      <ImageInput source="thumbnail" label="Thumbnail" accept="image/*" validate={[required()]}>
        <ImageField source="src" title="title" />
      </ImageInput>

      <SectionLabel icon={FolderIcon}>Production</SectionLabel>
      <TextInput fullWidth source="editorDirectory" label="Editor directory" helperText="Absolute path e.g. /unity-editor/" />
      <ReferenceInput label="Template File" reference="template-files" source="templateFile" perPage={100}>
        <SelectInput optionText="name" format={handleRelated} fullWidth />
      </ReferenceInput>
      <FileInput source="file" label="File">
        <FileField source="src" title="title" />
      </FileInput>
      <FileInput source="defaultConfig" label="Default Config JSON" accept="application/json" validate={[required()]}>
        <FileField source="src" title="title" />
      </FileInput>

      <SectionLabel icon={SettingsIcon}>Beta</SectionLabel>
      <BooleanInput source="betaEnabled" label="Enable Beta" />
      <TextInput fullWidth source="betaEditorDirectory" label="Beta editor directory" helperText="Beta editor path e.g. /unity-editor-beta/" />
      <ReferenceInput label="Beta Template File" reference="template-files" source="betaTemplateFile" perPage={100}>
        <SelectInput optionText="name" format={handleRelated} fullWidth />
      </ReferenceInput>
      <FileInput source="betaFile" label="Beta File">
        <FileField source="src" title="title" />
      </FileInput>
      <FileInput source="betaDefaultConfig" label="Beta Config JSON" accept="application/json">
        <FileField source="src" title="title" />
      </FileInput>

      <Divider sx={{ width: '100%', my: 2 }} />
      <BooleanInput source="disabled" />
      <BooleanInput source="featured" />
    </SimpleForm>
  </Create>
);

export default TemplateCreate;
